import React from 'react';
import { CameraIcon } from 'lucide-react';
import { profile } from '../../data/profil';
const fieldClass = 'w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-[15px] text-ville-navy placeholder:text-slate-400 transition-colors duration-150 ease-ville focus:border-ville-indigo focus:outline-none focus:ring-2 focus:ring-ville-indigo/20';
const labelClass = 'block text-sm font-semibold text-slate-600';
interface FieldProps {
  id: string;
  label: string;
  type?: string;
  defaultValue?: string;
  placeholder?: string;
}
function Field({
  id,
  label,
  type = 'text',
  defaultValue,
  placeholder
}: FieldProps) {
  return <div data-id="element-1918" data-mp="3baeoojcgvaqe">
      <label htmlFor={id} className={labelClass} data-id="element-1919" data-mp="3baok4mga6a3h">
        {label}
      </label>
      <input id={id} type={type} defaultValue={defaultValue} placeholder={placeholder} className={`mt-1.5 ${fieldClass}`} data-id="element-1920" data-mp="3g8py4syunj83" />
    </div>;
}
export function PersonalInfo() {
  return <section aria-labelledby="infos-titre" className="rounded-3xl border border-slate-200 bg-white p-6 sm:p-8" data-id="element-1921" data-mp="24sroamvukt5t">
      <h2 id="infos-titre" className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-1922" data-mp="16g6zx0rc15ee">
        Informations personnelles
      </h2>

      <div className="mt-6 flex flex-wrap items-center gap-5" data-id="element-1923" data-mp="1kh193lm7fae4">
        <span className="grid h-20 w-20 place-items-center rounded-full bg-ville-indigo-soft text-xl font-bold text-ville-indigo" aria-hidden="true" data-id="element-1924" data-mp="1fgvh24c0vlvi">
          {profile.initials}
        </span>
        <div data-id="element-1925" data-mp="1pfuq3o0p9jj1">
          <button type="button" className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1926" data-mp="1pdzzpu6nsz7k">
            <CameraIcon className="h-4 w-4" aria-hidden="true" data-id="element-1927" data-mp="285kkwb4gq5ay" />
            Changer ma photo
          </button>
          <p className="mt-2 text-xs text-slate-500" data-id="element-1928" data-mp="15seg31ds2e2u">JPG ou PNG, 5 Mo maximum.</p>
        </div>
      </div>

      <form className="mt-8 grid gap-5 sm:grid-cols-2" onSubmit={event => event.preventDefault()} data-id="element-1929" data-mp="19t87w5uccd10">
        <Field id="prenom" label="Prénom" defaultValue={profile.firstName} data-id="element-1930" data-mp="1eskt6m5kdc1h" />
        <Field id="nom" label="Nom de famille" defaultValue={profile.lastName} data-id="element-1931" data-mp="1jjjek05et0bl" />
        <Field id="naissance" label="Date de naissance" type="date" defaultValue={profile.birthDate} data-id="element-1932" data-mp="1jldxxa118kdk" />
        <Field id="courriel" label="Courriel" type="email" defaultValue={profile.email} data-id="element-1933" data-mp="1okyvph4gumop" />
        <Field id="tel" label="Téléphone principal" type="tel" defaultValue={profile.phone} data-id="element-1934" data-mp="1tjto9as8jpm0" />
        <Field id="tel-secondaire" label="Téléphone secondaire" type="tel" placeholder="Optionnel" defaultValue={profile.phoneSecondary} data-id="element-1935" data-mp="1xh7wp083dtcy" />
        <Field id="cellulaire" label="Téléphone cellulaire" type="tel" defaultValue={profile.mobile} data-id="element-1936" data-mp="374cano6d9qf" />
      </form>
    </section>;
}